<template>
  <div
    :id="id ? id + '-alert-marker' : null"
    class="cat-alert-marker nowrap"
    :class="type"
    tabindex="-1"
    :aria-label="offscreenMarkerText"
  >
    <cat-icon :icon="markerIcon" />
    <span
      v-if="!hideMarkerText"
      :aria-hidden="offscreenMarkerText ? 'true' : null"
      class="marker-text"
      :class="_markerTextCss"
      >{{ markerText }}</span
    >
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import CatIcon from "@/components/utilities/catIcon";
export default defineComponent({
  name: "CatAlertMarker",
  components: { CatIcon },
  props: {
    id: {
      type: [String, Number]
    },
    type: {
      type: String,
      description: "Possible values: error, warning, info, debug"
    },
    hideMarkerText: {
      type: Boolean,
      default: false,
      description:
        "Do not show the marker text on screen just the icon. Useful for small spaces."
    },
    markerTextClass: {
      type: String,
      description:
        "Styling to be applied on the marker text. Useful for responsive display. This parameter will override any default marker text styling."
    },
    markerText: {
      type: String,
      default: "Incomplete"
    },
    offscreenMarkerText: {
      type: String,
      description:
        "Accessible text to give more context of the text e.g. Director 1 is incomplete."
    }
  },
  computed: {
    _markerTextCss: function () {
      // Allow marker text styling to be overridden
      if (this.markerTextClass) {
        return this.markerTextClass;
      }
      return {
        "visible-for-large": true,
        "visible-for-medium": true,
        "word-wrap": true,
        "break-normal": true
      };
    },
    markerIcon: function () {
      if (this.type === "error" || this.type === "errors") {
        return "attention";
      } else if (this.type === "warning" || this.type === "warn") {
        return "attention-circled";
      } else if (this.type === "info") {
        return "info-circled";
      } else if (this.type === "debug") {
        return "ok-1";
      }
      return null;
    }
  }
});
</script>
